import { render } from "./QuestionAsker.vue?vue&type=template&id=214ca6c3&scoped=true"
import script from "./QuestionAsker.vue?vue&type=script&lang=js"
export * from "./QuestionAsker.vue?vue&type=script&lang=js"

import "./QuestionAsker.vue?vue&type=style&index=0&id=214ca6c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214ca6c3"]])

export default __exports__